<template>
  <div class="mod-config" style="position: relative;">
    <div style="position: absolute;top: 48px;right: 10px;margin-bottom: 0px;">
      <router-link to="/indexhome/device/batchAddition" replace>
        <el-button type="primary" @click="addOrUpdateHandle()" v-if="isAuth('device:addBatch')">批量新增</el-button>
      </router-link>
      <el-button type="primary" @click="addOrUpdateHandle()" v-if="isAuth('device:add')">新增</el-button>
      <el-dropdown placement="bottom" trigger="click">
        <el-button style="font-size: 16px;">更多</el-button>
        <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 226px;text-align: center;">
          <el-dropdown-item>
            <p @click="claimEquipment()" v-if="isAuth('device:addExist')">认领设备</p>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="deviceExcel()">导出Excel</p>
          </el-dropdown-item>
          <el-dropdown-item :disabled="dataListSelections.length <= 0" v-if="isAuth('device:delete')">
            <p @click="deleteHandle()">批量删除</p>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="addOrUpdateVisibleydkckr = true">可测可燃气体</p>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="addOrUpdateVisibleydyhqt = true">有毒有害气体传感器参数</p>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="addOrUpdateVisibleydvoc = true">可测挥发性有机化合物VOC</p>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="addOrUpdateVisiblevoc = true">VOC气体数据库</p>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="addOrUpdateVisibleyd = true">可燃气体数据库</p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <label>设备名称：</label>
        <template>
          <el-select v-model="dataForm.id" clearable placeholder="请输入关键词" filterable remote reserve-keyword
            :remote-method="remoteMethod" :loading="optionloading" style="width: 100%;">
            <el-option v-for="item in deviceOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item>
        <label>点位名称：</label>
        <el-input v-model="dataForm.poiName" placeholder="点位名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <label>企业名称：</label>
        <el-input v-model="dataForm.companyName" placeholder="企业" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <!-- <label>设备名称：</label> -->
        <!-- <el-input v-model="dataForm.name" placeholder="设备名称" clearable></el-input> -->
      </el-form-item>
      <el-form-item>
        <label>唯一编码：</label>
        <el-input v-model="dataForm.uniqueCode" placeholder="设备编码" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="margin-bottom: -40px;"></el-button>
    </el-form>
    <el-table :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 140px)" border stripe :header-cell-style="{ background: '#FAFAFA' }"
      placement="top">
      <el-table-column type="selection" header-align="center" align="center" width="40">
      </el-table-column>
      <el-table-column prop="id" header-align="center" align="center" label="ID" width="60" sortable>
      </el-table-column>
      <el-table-column prop="name" header-align="center" align="center" label="设备名称" color="#2db7f5"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="companyName" header-align="center" align="center" label="所属企业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="poiName" header-align="center" align="center" label="点位名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" header-align="center" align="center" label="点位地址" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="uniqueCode" header-align="center" align="center" label="唯一编码">
      </el-table-column>
      <el-table-column prop="statusName" header-align="center" align="center" label="设备状态" width="100">
      </el-table-column>
      <el-table-column prop="dataStatusName" header-align="center" align="center" label="数据状态" width="100">
        <template slot-scope="scope">
          <label v-if="scope.row.dataStatus == '1'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #00d67e;margin: 0 4px;"></i>合格
          </label>
          <label v-if="scope.row.dataStatus == '2'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #ff410a;margin: 0 4px;"></i>超标
          </label>
          <label v-if="scope.row.dataStatus == '3'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #767a81;margin: 0 4px;"></i>缺失
          </label>
          <label v-if="scope.row.dataStatus == '4'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #f9d00f;margin: 0 4px;"></i>故障
          </label>
        </template>
      </el-table-column>
      <el-table-column prop="warrantyTime" header-align="center" align="center" label="质保日期">
        <template slot-scope="scope">
          <div>{{ scope.row.warrantyTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="note" header-align="center" align="center" label="备注" width="176">
      </el-table-column>
      <el-table-column header-align="center" align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button type="text" @click="addOrUpdateHandle(scope.row.id)" style="font-size: 18px;padding: 0;"><i
                class="el-icon-edit-outline" v-if="isAuth('device:update')"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="text" @click="deleteHandle(scope.row.id)"
              style="font-size: 18px;padding: 0;margin-left: 0;" v-if="isAuth('device:delete')"><i
                class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="设备通道" placement="top">
            <router-link v-if="isAuth('deviceChannel:view')" title="设备通道"
              :to="{ path: '/indexhome/devicechannel', query: { id: scope.row.id } }" replace>
              <img src="../../assets/img/sbtd.png" alt="" width="18" height="18">
            </router-link>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="设备记录" placement="top">
            <router-link v-if="isAuth('deviceDetailRecordView:view')" title="设备记录"
              :to="{ path: '/indexhome/deviceDetailRecordView', query: { id: scope.row.id } }" replace>
              <el-button type="text" style="font-size: 18px;padding: 0;"><i
                  class="el-icon-data-analysis"></i></el-button>
            </router-link>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :page-size="pageSize"
      :total="totalPage" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

    <!-- 弹窗, 认领设备 -->
    <el-dialog title="认领设备" :visible.sync="theclaimEquipment" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="950px">
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="设备名称">
          <el-input v-model="dataFormrl.name" placeholder="设备名称"></el-input>
        </el-form-item>
        <el-form-item label="唯一编码">
          <el-input v-model="dataFormrl.uniqueCode" placeholder="唯一编码"></el-input>
        </el-form-item>
        <el-button type="primary" icon="el-icon-folder-delete" @click="dataFormSubmit()">查询</el-button>
        <div style="float: right;margin-bottom: 10px;">
          <el-button type="danger" :disabled="recycleSelections.length <= 0" @click="claim_delete()">批量删除</el-button>
          <el-button type="primary" :disabled="recycleSelections.length <= 0" @click="claim_batch()">批量认领</el-button>
        </div>
      </el-form>
      <el-table :data="deviceOptionrl" style="width: 100%;height: 84%;" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="name" label="设备名称" align="center">
        </el-table-column>
        <el-table-column prop="uniqueCode" label="唯一编码" align="center">
        </el-table-column>
        <!-- <el-table-column prop="address" label="操作" align="center" width="160">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="恢复" placement="top">
              <i class="el-icon-refresh" style="font-size: 24px;cursor: pointer;" @click="claim_batch(scope.row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i class="el-icon-delete-solid" style="font-size: 24px;cursor: pointer;"
                @click="claim_delete(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination @size-change="sizeChangeHandle_claim" @current-change="currentChangeHandle_claim"
        :page-size="pageSize_claim" :total="totalPage_claim" :current-page="pageIndex_claim" :page-sizes="[10, 50, 100]"
        layout="prev, pager, next, jumper, total,sizes">
      </el-pagination>
      <el-dialog width="22%" title="批量认领" :visible.sync="batchClaimVisible" :append-to-body="true"
        :close-on-click-modal="false">
        <div style="height: 50px;line-height: 50px;">
          <label style="font-size: 20px;width: 142px;display: inline-block;text-align: right;">认领设备数量：</label>
          <span>{{ recycleSelections.length }}</span>
        </div>
        <label style="font-size: 20px;width: 142px;display: inline-block;text-align: right;">认领至点位：</label>
        <el-select v-model="dataFormrl.poiId" filterable clearable placeholder="请选择"
          style="font-size: 14px;width: calc(100% - 150px);">
          <el-option v-for="item in deviceOptClaim" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div style="bottom: 20px;position: absolute;right: 20px;">
          <el-button type="primary" :disabled="recycleSelections.length <= 0" @click="claimGetDdata()">确定</el-button>
          <el-button type="danger" :disabled="recycleSelections.length <= 0"
            @click="batchClaimVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </el-dialog>

    <!-- VOC气体数据库 -->
    <el-dialog title="VOC气体数据库" :visible.sync="addOrUpdateVisiblevoc" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="500px" class="ydqt">
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="气体名称">
          <el-input v-model="searchQuery" placeholder="输入关键词搜索"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="deviceOptionrlvoc.filter(data => !searchQuery || data.name.toLowerCase().includes(searchQuery.toLowerCase()))"
        style="width: 100%;margin-top: 10px;" height="560" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle">
        <el-table-column prop="name" label="气体名称" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 可燃气体数据库 -->
    <el-dialog title="可燃气体数据库" :visible.sync="addOrUpdateVisibleyd" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="500px" class="ydqt">
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="气体名称">
          <el-input v-model="searchQueryyd" placeholder="输入关键词搜索"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="deviceOptionrlyd.filter(data => !searchQueryyd || data.name.toLowerCase().includes(searchQueryyd.toLowerCase()))"
        style="width: 100%;margin-top: 10px;" height="560" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle">
        <!-- <el-table-column label="序号" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column> -->
        <el-table-column prop="name" label="气体名称" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 可测可燃气体 -->
    <el-dialog title="可测可燃气体" :visible.sync="addOrUpdateVisibleydkckr" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true">
      <!-- <p>危报品传感器报警值</p> -->
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="气体名称">
          <el-input v-model="searchQueryyd" placeholder="输入关键词搜索"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableDatakckr.filter(data => !searchQueryyd || data.name.toLowerCase().includes(searchQueryyd.toLowerCase()))"
        style="width: 100%;margin-top: 10px;" height="calc(100% - 60px)" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle">
        <el-table-column prop="date" label="编码" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="气体名称" align="center">
        </el-table-column>
        <el-table-column prop="formula" label="化学式" align="center">
        </el-table-column>
        <el-table-column prop="rangeValue" label="测量范围" align="center">
        </el-table-column>
        <el-table-column prop="a1Alarm" label="A1低报警值" align="center">
        </el-table-column>
        <el-table-column prop="a2Alarm" label="A2高报警值" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 有毒有害气体传感器参数 -->
    <el-dialog title="有毒有害气体传感器参数" :visible.sync="addOrUpdateVisibleydyhqt" :modal-append-to-body="false"
      :show-close="true" :close-on-click-modal="false" :append-to-body="true">
      <!-- <p>危报品传感器报警值</p> -->
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="气体名称">
          <el-input v-model="searchQueryyd" placeholder="输入关键词搜索"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableDataydyh.filter(data => !searchQueryyd || data.name.toLowerCase().includes(searchQueryyd.toLowerCase()))"
        style="width: 100%;margin-top: 10px;" height="calc(100% - 60px)" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle">
        <el-table-column prop="date" label="编码" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="气体名称" align="center">
        </el-table-column>
        <el-table-column prop="formula" label="化学式" align="center">
        </el-table-column>
        <el-table-column prop="rangeValue" label="测量范围" align="center">
        </el-table-column>
        <el-table-column prop="a1Alarm" label="A1低报警值" align="center">
        </el-table-column>
        <el-table-column prop="a2Alarm" label="A2高报警值" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 可测挥发性有机化合物VOC -->
    <el-dialog title="可测挥发性有机化合物VOC" :visible.sync="addOrUpdateVisibleydvoc" :modal-append-to-body="false"
      :show-close="true" :close-on-click-modal="false" :append-to-body="true">
      <!-- <p>危报品传感器报警值</p> -->
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="气体名称">
          <el-input v-model="searchQueryyd" placeholder="输入关键词搜索"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableDatavoc.filter(data => !searchQueryyd || data.name.toLowerCase().includes(searchQueryyd.toLowerCase()))"
        style="width: 100%;margin-top: 10px;" height="calc(100% - 60px)" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle" :span-method="arraySpanMethod" :row-key="getRowKey">
        <el-table-column prop="name" label="气体名称" align="center">
        </el-table-column>
        <el-table-column prop="formula" label="化学式" align="center">
        </el-table-column>
        <el-table-column prop="rangeValue" label="测量范围" align="center">
        </el-table-column>
        <el-table-column prop="a1Alarm" label="A1低报警值" align="center">
        </el-table-column>
        <el-table-column prop="a2Alarm" label="A2高报警值" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from './device-add-or-update'
import { excel, isAuth } from "@/utils";
import toxic from './toxic'
let ids, dispatchId;
export default {
  name: 'device',
  data() {
    return {
      tableDataydyh: [],
      tableDatakckr: [],
      tableDatavoc: [],
      dataForm: {
        params: ''
      },
      dataFormrl: {
        uniqueCode: '',
        name: '',
        poiId: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      pageIndex_claim: 1,
      pageSize_claim: 10,
      totalPage_claim: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      addOrUpdateVisiblevoc: false,
      addOrUpdateVisibleyd: false,
      addOrUpdateVisibleydyhqt: false,
      addOrUpdateVisibleydkckr: false,
      addOrUpdateVisibleydvoc: false,
      theclaimEquipment: false,
      batchClaimVisible: false,

      deviceOption: [],
      deviceOptionlist: [],
      optionloading: false,

      deviceOptionrl: [],
      deviceOptionrlvoc: [],
      deviceOptionrlyd: [],
      recycleSelections: [],
      deviceOptClaim: [],
      searchQuery: '',
      searchQueryyd: ''
    }
  },
  components: {
    AddOrUpdate,
  },
  created() {
    this.getDataList()
    this.getDeviceOptions()
    this.deviceOptionrlvoc = toxic.index
    this.deviceOptionrlyd = toxic.srt_index
    this.$http({
      url: this.$http.adornUrl('hazardous/option?type=1'),
      method: 'get',
    }).then(({ data }) => {
      if (data && data.code === 200) {
        this.tableDatakckr = data.data
      }
    })
    this.$http({
      url: this.$http.adornUrl('hazardous/option?type=0'),
      method: 'get',
    }).then(({ data }) => {
      if (data && data.code === 200) {
        this.tableDataydyh = data.data
      }
    })
    this.$http({
      url: this.$http.adornUrl('hazardous/option?type=2'),
      method: 'get',
    }).then(({ data }) => {
      if (data && data.code === 200) {
        data.data.forEach(item => {
          item.gasList.forEach(items => {
            this.tableDatavoc.push(items)
          })
        })
        console.log(this.tableDatavoc)
      }
    })
  },
  methods: {
    getRowKey(row) {
      return row.id; // 使用对象的id作为唯一键值
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) { // 假设我们要合并第一列
        const prevRow = this.tableDatavoc[rowIndex - 1];
        if (prevRow && row.name === prevRow.name) {
          return { rowspan: 0, colspan: 1 };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableDatavoc.length; i++) {
            if (this.tableDatavoc[i].name === row.name) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        }
      } else if (columnIndex === 1) { // 假设我们要合并第一列
        const prevRow = this.tableDatavoc[rowIndex - 1];
        if (prevRow && row.formula === prevRow.formula) {
          return { rowspan: 0, colspan: 1 };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableDatavoc.length; i++) {
            if (this.tableDatavoc[i].formula === row.formula) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        }
      }
    },
    // 远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.optionloading = true
        setTimeout(() => {
          this.optionloading = false
          this.deviceOption = this.deviceOptionlist.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.deviceOption = [];
      }
    },
    /**
     * 认领————批量认领&&批量删除
     * @param val
     */
    recycleChangeHandle(val) {
      this.recycleSelections = val;
    },
    claim_delete(id) {
      if (id) {
        ids = id.name ? [id.name] : this.recycleSelections.map(item => {
          return item.name
        })
        dispatchId = id.id ? [id.id] : this.recycleSelections.map(item => {
          return item.id
        })
      } else {
        ids = id ? [id] : this.recycleSelections.map(item => {
          return item.name
        })
        dispatchId = id ? [id] : this.recycleSelections.map(item => {
          return item.id
        })
      }
      this.$confirm(`确定对[设备：${ids.join(',')}]进行[${ids ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("device/deleteClaimList"),
          method: 'post',
          data: this.$http.adornData(dispatchId, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.dataFormSubmit()
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    claim_batch(id) {
      if (id) {
        ids = id.name ? [id.name] : this.recycleSelections.map(item => {
          return item.name
        })
        dispatchId = id.id ? [id.id] : this.recycleSelections.map(item => {
          return item.id
        })
      } else {
        ids = id ? [id] : this.recycleSelections.map(item => {
          return item.name
        })
        dispatchId = id ? [id] : this.recycleSelections.map(item => {
          return item.id
        })
      }
      this.batchClaimVisible = true
      this.$http({
        url: this.$http.adornUrl('poi/option'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.deviceOptClaim = data.data.poiOption;
        }
      })
    },
    claimGetDdata() {
      this.$confirm(`确定对[设备：${ids.join(',')}]进行[${ids ? '认领' : '批量认领'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("device/claimExistDevice"),
          method: 'post',
          data: this.$http.adornData({
            'ids': dispatchId,
            'poiId': this.dataFormrl.poiId
          })
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.dataFormSubmit()
            this.batchClaimVisible = false
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },



    claimEquipment() {
      this.theclaimEquipment = true;
      this.dataFormrl = {}
      this.dataFormSubmit();
    },
    dataFormSubmit() {
      this.$http({
        url: this.$http.adornUrl('device/claimDeviceList'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex_claim,
          'pageSize': this.pageSize_claim,
          'name': this.dataFormrl.name,
          'uniqueCode': this.dataFormrl.uniqueCode,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.deviceOptionrl = data.data.rows;
          this.totalPage_claim = data.data.total
        } else {
          this.deviceOptionrl = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
      })
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl("/device/list"),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'id': this.dataForm.id,
          'companyName': this.dataForm.companyName,
          'poiName': this.dataForm.poiName,
          'uniqueCode': this.dataForm.uniqueCode,
          'name': this.dataForm.name,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          data.data.rows.map(item => {
            if (item.warrantyTime != null) {
              item.warrantyTime = item.warrantyTime.substring(0, 10)
            }
          })
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    /**
    * 设备分页
    * @param {*} val 
    */
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },


    /**
     * 认领分页
     * @param {*} val 
     */
    sizeChangeHandle_claim(val) {
      this.pageSize_claim = val;
      this.pageIndex_claim = 1;
      this.dataFormSubmit();
    },
    // 当前页
    currentChangeHandle_claim(val) {
      this.pageIndex_claim = val;
      this.dataFormSubmit();
    },
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      })
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("/device/delete"),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //导出
    deviceExcel() {
      excel("/device/excel", "设备信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'params': this.dataForm.params,
      })
    },
    //获取设备下拉框数据
    getDeviceOptions() {
      this.$http({
        url: this.$http.adornUrl('device/option'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.deviceOptionlist = data.data.deviceOption;
        }
      })
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
  }
}
</script>

<style scoped>
@import '../../assets/css/indexhome.css';
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/device.vue